import "slick-carousel";

export default class GridSlider {
    selector = '.grid-four-columns-slider > .jet-listing-grid > .jet-listing-grid__items';
    constructor() {
        this.slickInitialized = false;
        this.addEvents();
    }

    addEvents() {
        this.initSlickCarousel();
        this.handleResize();
    }

    initSlickCarousel() {
        if (window.innerWidth < 768 && !this.slickInitialized) {
            // Check if the document direction is RTL
            const isRTL = document.dir === 'rtl' || $('html').attr('dir') === 'rtl' || $('body').attr('dir') === 'rtl';
            
            $(this.selector).slick({
                slidesToShow: 1,
                variableWidth: true,
                infinite: false,
                arrows: false,
                mobileFirst: true,
                rtl: isRTL // Set RTL based on document direction
            });
            this.slickInitialized = true;
        }
    }

    destroySlickCarousel() {
        if (this.slickInitialized) {
            $(this.selector).slick('unslick');
            this.slickInitialized = false;
        }
    }

    handleResize() {
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 768) {
                this.destroySlickCarousel();
            } else {
                this.initSlickCarousel();
            }
        });
    }
}